// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"0daac809","420":"3223ae99","787":"9c515f4b","804":"3888b88d","881":"7bc30e68"}[chunkId] + ".chunk.js";
};